"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LLMTrainer = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const TrainerStorageService_1 = __importStar(require("./services/TrainerStorageService"));
const trainer_types_1 = require("./types/trainer.types");
// Import child components
require("./children/instructions/component");
require("./children/upload/component");
require("./children/config/component");
require("./children/progress/component");
require("./children/results/component");
const events_1 = require("./events");
//@ts-ignore                
let rwsTemplate = T.html `<template>
    <div class="trainer-container">
        
        <div class="trainer-header">
            <h1>${'trainer.title'.t()}</h1>
            <div class="header-actions">
                <button type="button" class="btn btn-secondary" @click="${x => x.resetTrainer()}">
                    ${'trainer.reset.button'.t()}
                </button>
            </div>
        </div>

        
        <div class="message-container" class="${x => x.state.message ? `show ${x.state.message.type}` : ''}">
            <div class="message" ?hidden="${x => !x.state.message}">
                <span class="message-text">${x => { var _a; return ((_a = x.state.message) === null || _a === void 0 ? void 0 : _a.text) || ''; }}</span>
                <button type="button" class="message-close" @click="${x => x.clearMessage()}">
                    ×
                </button>
            </div>
        </div>

        
        <div class="trainer-tabs">
            <button 
                type="button" 
                class="tab-button ${x => x.state.activeTab === 'instructions' ? 'active' : ''}"
                @click="${x => x.setActiveTab('instructions')}"
            >
                <span class="tab-number">📚</span>
                <span class="tab-label">${'trainer.tab.instructions'.t()}</span>
            </button>
            
            <button 
                type="button" 
                class="tab-button ${x => x.state.activeTab === 'upload' ? 'active' : ''}"
                @click="${x => x.setActiveTab('upload')}"
            >
                <span class="tab-number">1</span>
                <span class="tab-label">${'trainer.tab.upload'.t()}</span>
            </button>
            
            <button 
                type="button" 
                class="tab-button ${x => x.state.activeTab === 'config' ? 'active' : ''} ${x => x.canNavigateToTab('config') ? '' : 'disabled'}"
                @click="${x => x.setActiveTab('config')}"
                ?disabled="${x => !x.canNavigateToTab('config')}"
            >
                <span class="tab-number">2</span>
                <span class="tab-label">${'trainer.tab.config'.t()}</span>
            </button>
            
            <button 
                type="button" 
                class="tab-button ${x => x.state.activeTab === 'training' ? 'active' : ''} ${x => x.canNavigateToTab('training') ? '' : 'disabled'}"
                @click="${x => x.setActiveTab('training')}"
                ?disabled="${x => !x.canNavigateToTab('training')}"
            >
                <span class="tab-number">3</span>
                <span class="tab-label">${'trainer.tab.training'.t()}</span>
            </button>
            
            <button 
                type="button" 
                class="tab-button ${x => x.state.activeTab === 'results' ? 'active' : ''} ${x => x.canNavigateToTab('results') ? '' : 'disabled'}"
                @click="${x => x.setActiveTab('results')}"
                ?disabled="${x => !x.canNavigateToTab('results')}"
            >
                <span class="tab-number">4</span>
                <span class="tab-label">${'trainer.tab.results'.t()}</span>
            </button>
        </div>

        
        <div class="trainer-content">
            
            <div class="tab-content ${x => x.state.activeTab === 'instructions' ? 'active' : ''}">
                <trainer-instructions></trainer-instructions>
            </div>
            
            
            <div class="tab-content ${x => x.state.activeTab === 'upload' ? 'active' : ''}">
                <trainer-upload
                    :selectedFile="${x => x.state.selectedFile}"
                    :isFileLoading="${x => x.state.isFileLoading}"
                    :parsedData="${x => x.state.parsedData}"
                    :validationResult="${x => x.state.validationResult}"
                    :dataStatistics="${x => x.state.dataStatistics}"
                ></trainer-upload>
            </div>

            
            <div class="tab-content ${x => x.state.activeTab === 'config' ? 'active' : ''}">
                <trainer-config
                    :trainingConfig="${x => x.state.trainingConfig}"
                    :parsedData="${x => x.state.parsedData}"
                    :dataStatistics="${x => x.state.dataStatistics}"
                ></trainer-config>
            </div>

            
            <div class="tab-content ${x => x.state.activeTab === 'training' ? 'active' : ''}">
                <trainer-progress
                    :trainingProgress="${x => x.state.trainingProgress}"
                    :trainingConfig="${x => x.state.trainingConfig}"
                    :parsedData="${x => x.state.parsedData}"
                ></trainer-progress>
            </div>

            
            <div class="tab-content ${x => x.state.activeTab === 'results' ? 'active' : ''}">
                <trainer-results
                    :trainingResults="${x => x.state.trainingResults}"
                    :trainingConfig="${x => x.state.trainingConfig}"
                    :parsedData="${x => x.state.parsedData}"
                    :trainingProgress="${x => x.state.trainingProgress}"
                    :dataStatistics="${x => x.state.dataStatistics}"
                ></trainer-results>
            </div>
        </div>
    </div>
</template>
`;
require("./styles/layout.scss");
const styles = T.css `.trainer-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--background-color, #ffffff);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.trainer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.trainer-header h1 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.trainer-header .header-actions .btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.trainer-header .header-actions .btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.message-container {
  position: relative;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
.message-container.show {
  max-height: 100px;
}
.message-container .message {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  margin: 0;
  border: none;
  font-size: 0.9rem;
  font-weight: 500;
}
.message-container .message .message-text {
  flex: 1;
}
.message-container .message .message-close {
  background: none;
  border: none;
  color: inherit;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  padding: 0;
  margin-left: 1rem;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}
.message-container .message .message-close:hover {
  opacity: 1;
}
.message-container.success .message {
  background: #d4edda;
  color: #155724;
  border-left: 4px solid #28a745;
}
.message-container.error .message {
  background: #f8d7da;
  color: #721c24;
  border-left: 4px solid #dc3545;
}
.message-container.warning .message {
  background: #fff3cd;
  color: #856404;
  border-left: 4px solid #ffc107;
}
.message-container.info .message {
  background: #d1ecf1;
  color: #0c5460;
  border-left: 4px solid #17a2b8;
}

.trainer-tabs {
  display: flex;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0 2rem;
}
.trainer-tabs .tab-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  padding: 1rem 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6c757d;
  font-size: 0.9rem;
  font-weight: 500;
  position: relative;
  margin-bottom: -1px;
}
.trainer-tabs .tab-button .tab-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e9ecef;
  color: #6c757d;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.2s ease;
}
.trainer-tabs .tab-button .tab-label {
  white-space: nowrap;
}
.trainer-tabs .tab-button:hover:not(.disabled) {
  color: #495057;
}
.trainer-tabs .tab-button:hover:not(.disabled) .tab-number {
  background: #dee2e6;
}
.trainer-tabs .tab-button.active {
  color: #667eea;
  background: white;
  border-bottom: 2px solid #667eea;
}
.trainer-tabs .tab-button.active .tab-number {
  background: #667eea;
  color: white;
}
.trainer-tabs .tab-button.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.trainer-tabs .tab-button.disabled .tab-number {
  background: #f8f9fa;
  color: #adb5bd;
}

.trainer-content {
  flex: 1;
  overflow: hidden;
  position: relative;
}
.trainer-content .tab-content {
  opacity: 0;
  display: none;
  transition: all 0.3s ease;
}
.trainer-content .tab-content.active {
  opacity: 1;
  display: block;
  visibility: visible;
}

@media (max-width: 768px) {
  .trainer-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  .trainer-header h1 {
    font-size: 1.5rem;
  }
  .trainer-tabs {
    padding: 0 1rem;
    overflow-x: auto;
  }
  .trainer-tabs .tab-button {
    padding: 0.75rem 1rem;
    min-width: max-content;
  }
  .trainer-tabs .tab-button .tab-label {
    display: none;
  }
  .message-container .message {
    padding: 0.75rem 1rem;
    font-size: 0.8rem;
  }
}
@media (max-width: 480px) {
  .trainer-header {
    padding: 0.75rem;
  }
  .trainer-header h1 {
    font-size: 1.25rem;
  }
  .trainer-tabs {
    padding: 0 0.5rem;
  }
  .trainer-tabs .tab-button {
    padding: 0.5rem 0.75rem;
    gap: 0.25rem;
  }
  .trainer-tabs .tab-button .tab-number {
    width: 20px;
    height: 20px;
    font-size: 0.7rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let LLMTrainer = class LLMTrainer extends client_1.RWSViewComponent {
    constructor(trainerStorageService) {
        super();
        this.trainerStorageService = trainerStorageService;
        this.state = {
            activeTab: 'instructions',
            selectedFile: null,
            isFileLoading: false,
            parsedData: [],
            validationResult: null,
            dataStatistics: {
                totalSamples: 0,
                averageInputLength: 0,
                averageOutputLength: 0,
                categories: [],
                qualityScore: 0
            },
            trainingConfig: {
                modelName: '',
                baseModel: null,
                useFineTuning: 'lora',
                epochs: 3,
                learningRate: 0.0001,
                batchSize: 16,
                validationSplit: 0.2,
                isSent: false
            },
            trainingProgress: {
                stage: 'idle',
                progress: 0
            },
            trainingResults: null,
            message: null
        };
    }
    connectedCallback() {
        super.connectedCallback();
        // Load saved state
        const savedState = this.trainerStorageService.loadTrainerState();
        if (savedState) {
            this.state = { ...this.state, ...savedState };
        }
        // Initialize child components after they're rendered
        this.setupChildComponentListeners();
    }
    setupChildComponentListeners() {
        // Set up event listeners for child components
        this.on(events_1.trainerEvents.textCopied, this.handleTextCopied.bind(this));
        this.on(events_1.trainerEvents.dataUploaded, (event) => {
            this.handleDataUploaded(event.detail);
        });
        this.on(events_1.trainerEvents.fileUploaded, (event) => {
            console.log({ event });
            this.handleDataUploaded(event.detail);
        });
        this.on(events_1.trainerEvents.uploadError, this.handleUploadError.bind(this));
        this.on(events_1.trainerEvents.configUpdated, this.handleConfigUpdated.bind(this));
        this.on(events_1.trainerEvents.configValidated, this.handleConfigValidated.bind(this));
        this.on(events_1.trainerEvents.trainingStarted, this.handleTrainingStarted.bind(this));
        this.on(events_1.trainerEvents.trainingProgress, this.handleTrainingProgress.bind(this));
        this.on(events_1.trainerEvents.trainingCompleted, this.handleTrainingCompleted.bind(this));
        this.on(events_1.trainerEvents.trainingError, this.handleTrainingError.bind(this));
        this.on(events_1.trainerEvents.uploadSuccess, this.handleUploadSuccess.bind(this));
        this.on(events_1.trainerEvents.uploadWarning, this.handleUploadWarning.bind(this));
        this.on(events_1.trainerEvents.configChanged, this.handleConfigChanged.bind(this));
        this.on(events_1.trainerEvents.trainingStopped, this.handleTrainingStopped.bind(this));
        this.on(events_1.trainerEvents.deployModel, this.handleDeployModel.bind(this));
        this.on(events_1.trainerEvents.testModel, this.handleTestModel.bind(this));
        this.on(events_1.trainerEvents.activeTabSet, (event) => {
            const tab = event.detail;
            this.setActiveTab(tab);
        });
    }
    // Tab navigation
    setActiveTab(tab) {
        // Validate tab transition
        if (!this.canNavigateToTab(tab)) {
            this.showMessage(`Please complete the ${this.getRequiredStepForTab(tab)} step first.`, 'warning');
            return;
        }
        if (tab === 'upload') {
            this.state = { ...this.state, trainingConfig: { ...this.state.trainingConfig, isSent: false } };
        }
        this.state = { ...this.state, activeTab: tab };
        this.trainerStorageService.saveTrainerState(this.state);
    }
    canNavigateToTab(tab) {
        var _a;
        switch (tab) {
            case 'instructions':
            case 'upload':
                return true;
            case 'config':
                return this.state.parsedData.length > 0;
            case 'training':
                return this.state.trainingConfig.isSent;
            case 'results':
                return ((_a = this.state.trainingProgress) === null || _a === void 0 ? void 0 : _a.stage) === 'completed';
            default:
                return false;
        }
    }
    getRequiredStepForTab(tab) {
        switch (tab) {
            case 'config':
                return 'data upload and validation';
            case 'training':
                return 'configuration';
            case 'results':
                return 'training';
            default:
                return '';
        }
    }
    // Event handlers for child components
    handleTextCopied(event) {
        const { text } = event.detail;
        this.showMessage(text, 'info');
    }
    handleDataUploaded(eventDetail) {
        const { file, data, validation, statistics } = eventDetail;
        this.state = {
            ...this.state,
            selectedFile: file,
            parsedData: data,
            validationResult: validation, // Assume valid for now
            dataStatistics: statistics,
            isFileLoading: false
        };
        if (this.state.validationResult.isValid) {
            this.showMessage('File uploaded and validated successfully!', 'success');
        }
        else {
            this.showMessage('File validation failed. Please check the errors.', 'error');
        }
        this.trainerStorageService.saveTrainerState(this.state);
    }
    handleUploadError(event) {
        const { error } = event.detail;
        this.state = { ...this.state, isFileLoading: false };
        this.showMessage(`Upload error: ${error}`, 'error');
    }
    handleConfigUpdated(event) {
        const { config } = event.detail;
        this.state = { ...this.state, trainingConfig: config };
        if (this.state.trainingConfig.isSent) {
            this.setActiveTab('training');
        }
        this.trainerStorageService.saveTrainerState(this.state);
    }
    handleConfigValidated(event) {
        const { isValid, message } = event.detail;
        if (isValid) {
            this.showMessage('Configuration validated successfully!', 'success');
        }
        else {
            this.showMessage(`Configuration error: ${message}`, 'error');
        }
    }
    handleTrainingStarted(event) {
        this.state = {
            ...this.state,
            trainingProgress: {
                stage: 'preparing',
                progress: 0,
                message: 'Preparing training data...'
            }
        };
        this.setActiveTab('training');
        this.trainerStorageService.saveTrainerState(this.state);
    }
    handleTrainingProgress(event) {
        const { progress } = event.detail;
        this.state = { ...this.state, trainingProgress: progress };
        this.trainerStorageService.saveTrainerState(this.state);
    }
    handleTrainingCompleted(event) {
        const { results } = event.detail;
        this.state = {
            ...this.state,
            trainingProgress: {
                stage: 'completed',
                progress: 100,
                message: 'Training completed successfully!'
            },
            trainingResults: results
        };
        this.showMessage('Training completed successfully!', 'success');
        this.setActiveTab('results');
        this.trainerStorageService.saveTrainerState(this.state);
    }
    handleTrainingError(event) {
        const { error } = event.detail;
        this.state = {
            ...this.state,
            trainingProgress: {
                stage: 'error',
                progress: 0,
                message: `Training failed: ${error}`
            }
        };
        this.showMessage(`Training error: ${error}`, 'error');
    }
    handleUploadSuccess(event) {
        const { message } = event.detail;
        this.showMessage(message, 'success');
    }
    handleUploadWarning(event) {
        const { message } = event.detail;
        this.showMessage(message, 'warning');
    }
    handleConfigChanged(event) {
        const config = event.detail;
        this.state = { ...this.state, trainingConfig: config };
        this.trainerStorageService.saveTrainerState(this.state);
    }
    handleTrainingStopped(event) {
        this.state = {
            ...this.state,
            trainingProgress: {
                stage: 'idle',
                progress: 0
            }
        };
        this.showMessage('Training stopped', 'warning');
        this.trainerStorageService.saveTrainerState(this.state);
    }
    handleDeployModel(event) {
        const { modelId, config } = event.detail;
        this.showMessage(`Deploying model ${modelId}...`, 'info');
        // TODO: Implement model deployment logic
    }
    handleTestModel(event) {
        const { modelId, config } = event.detail;
        this.showMessage(`Testing model ${modelId}...`, 'info');
        // TODO: Implement model testing logic
    }
    showMessage(text, type = 'info') {
        this.state = {
            ...this.state,
            message: { text, type }
        };
        // Auto-hide message after 5 seconds
        setTimeout(() => {
            this.state = { ...this.state, message: null };
        }, 5000);
    }
    // Method to clear message manually
    clearMessage() {
        this.state = { ...this.state, message: null };
    }
    // Reset trainer state
    resetTrainer() {
        this.state = {
            activeTab: 'instructions',
            selectedFile: null,
            isFileLoading: false,
            parsedData: [],
            validationResult: null,
            dataStatistics: {
                totalSamples: 0,
                averageInputLength: 0,
                averageOutputLength: 0,
                categories: [],
                qualityScore: 0
            },
            trainingConfig: this.trainerStorageService.getDefaultTrainingConfig(),
            trainingProgress: {
                stage: 'idle',
                progress: 0
            },
            trainingResults: null,
            message: null
        };
        this.trainerStorageService.clearTrainerState();
        this.showMessage('Trainer reset successfully!', 'info');
    }
};
exports.LLMTrainer = LLMTrainer;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof trainer_types_1.TrainerState !== "undefined" && trainer_types_1.TrainerState) === "function" ? _b : Object)
], LLMTrainer.prototype, "state", void 0);
exports.LLMTrainer = LLMTrainer = __decorate([
    (0, client_1.RWSView)('llm-trainer', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(TrainerStorageService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof TrainerStorageService_1.TrainerStorageServiceInstance !== "undefined" && TrainerStorageService_1.TrainerStorageServiceInstance) === "function" ? _a : Object])
], LLMTrainer);
LLMTrainer.defineComponent();
